module.exports = __webpack_public_path__ + "static/media/service.0b0cb5aa.png";